const CUSTOMER_BACKEND_URL = {
  GIGA_PROD: 'https://sixsense-api.sgp-aws.gfoundries.com',
  GIGA: 'http://staging-sixsense-api.sgp-aws.gfoundries.com',
  GF7: 'https://f7staging-sixsense-api.sgp-aws.gfoundries.com',
  GF7_PROD: 'https://f7prod-sixsense-api.sgp-aws.gfoundries.com',
};

let BACKEND_URL = '';
if (!import.meta || import.meta.env.MODE === 'development') {
  BACKEND_URL = 'https://sixsense-qa.staging.sixsense.ai';
  // BACKEND_URL = 'http://127.0.0.1:8000';
} else {
  BACKEND_URL =
    import.meta.env.VITE_APP_USE_ORIGIN_URL === 'true'
      ? // eslint-disable-next-line no-restricted-globals
        location.origin
      : CUSTOMER_BACKEND_URL[import.meta.env.VITE_APP_CUSTOMER];
}

export default BACKEND_URL;
